module.exports = __webpack_public_path__ + "img/4d4847f46f8f03bcc9d1a1deb6d537f2.svg";